import { Injectable } from '@angular/core';

@Injectable()
export class FoucsChangeService {
    constructor() {
    }

    changeFocus(enable: boolean) {
        setTimeout(function () {
            //var focusable = Array.from(document.querySelectorAll('.focusable'));
            var focusable = Array.from(document.querySelectorAll('a[href], area[href], input:not([disabled]):not(.actionCloseLightbox2):not(.actionCloseLightbox), select:not([disabled]), textarea:not([disabled]), button:not([disabled]):not(.actionCloseLightbox2), iframe, object, embed, *[tabindex], *[contenteditable]')); 
            //var focusable = Array.from(document.querySelectorAll('a[href], area[href], input:not([disabled]):not(.actionCloseLightbox2):not(.actionCloseLightbox), select:not([disabled]), textarea:not([disabled]), button:not([disabled]):not(.actionCloseLightbox2), iframe, object, embed, *[tabindex], *[contenteditable]')); 

            focusable.forEach(el => el.setAttribute('tabindex', enable ? "0" : "-1"));
        }, 0);
    }
}